module.exports = "<cellwatch-navbar></cellwatch-navbar>\r\n\r\n<main role=\"main\" class=\"container\">\r\n\r\n  <router-outlet></router-outlet>\r\n\r\n</main>\r\n"


//////////////////
// WEBPACK FOOTER
// /Users/Michel/Documents/edenz_local/cellwatchWebApp/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main